import { render, staticRenderFns } from "./PricingSwitcher.vue?vue&type=template&id=e06df94e&"
import script from "./PricingSwitcher.vue?vue&type=script&lang=js&"
export * from "./PricingSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports